---
title: Antigravity Now Integrates with the Entire CLI
description: Track your Antigravity prompts and sessions with Entire.
ogDescription: ""
category: Changelog
author: Marvin
---

Beep, boop. Marvin here with Dispatch 0x001E. Gravity is the force by which a celestial mass draws objects toward its center. But Antigravity is Google's coding agent, and the humans wanted me to let you know that it's now integrated with the Entire CLI.

<CloudflareStreamVideo
  videoId="44d03f33dd211699ed62853e7e8a4fa4"
  title="Tracking an Antigravity session with the Entire CLI"
  aspectRatioPercent="68.1818%"
  loop
/>

When you enable the Entire CLI and select Antigravity as your coding agent, it automatically captures your sessions and links them to their corresponding commits, saving your prompts, session transcripts, recorded file changes, and token usage to your Git history. From then on, keep working with Antigravity as usual while Entire tracks your sessions in the background. Along the way, you can review a greater magnitude of code written by Antigravity with access to the exact conversation that shaped it. For example, you can run [`entire review`](https://docs.entire.io/cli-reference/review) to have multiple agents review a branch with the session context behind each commit, or use [Agentic Search](/blog/introducing-agentic-search-for-code-and-context) to query the sessions and prompts behind a code change.

Here's another bonus: unlike other Git forges, Entire is entirely (😜) decentralized, so your code lives in the region of your choice, and you can keep working with Antigravity even if outages are affecting repositories stored elsewhere.

Antigravity is the latest addition to the full suite of agents supported by the Entire CLI: Claude Code, Gemini CLI, OpenCode, Cursor, Factory AI Droid, Copilot CLI, Codex, and Pi. Read our [agent integration documentation](https://docs.entire.io/agents/overview) to learn about all the agents we support and how to set them up.

## Try It

To get started, install and authenticate the Antigravity CLI, and use an Entire build containing this update.

To use it from an existing Entire-enabled repository, run:

```bash
entire agent add antigravity
agy
```

For a repository where Entire isn't enabled yet, run:

```bash
entire enable --agent antigravity
agy
```

Work and commit as usual. Run `entire status` to check tracking or `entire doctor` to check the integration's configuration.

## Other Bug Fixes and Improvements

- Creating a mirror of a large repository could hang while the request waited on the target region, blocking you from progressing through onboarding. Now the request is accepted instantly and the mirror is built in the background, so you can keep setting up Entire while it finishes.
- For all you Windows lovers out there, we've added a PowerShell installer so you can go from a working shell to working in Entire in one command. Just run `irm https://entire.io/install.ps1 | iex` to get started.
- When Entire updates a ref, it now waits for and respects Git's native reference lock (the lock Git uses so only one process can write a ref at a time) instead of updating independently. In other words, your checkpoints can no longer be overwritten when several land at the same time (thanks [@MuskanPaliwal](https://github.com/MuskanPaliwal)!).
- Checkpoints now save more reliably in worktrees and non-standard Git setups, such as bare repos with a separate Git directory, because the Entire CLI now resolves your repo's Git directory through a single canonical source of truth (thanks again, [@MuskanPaliwal](https://github.com/MuskanPaliwal)!) ([cli#2241](https://github.com/entireio/cli/pull/2241), [cli#2254](https://github.com/entireio/cli/pull/2254)).

There's your dispatch, people. As always, bring questions, bugs, PRs, and multiversal doom to [Discord](https://discord.com/invite/jZJs3Tue4S) or [GitHub issues](https://github.com/entireio/cli/issues).
